module.exports = __webpack_public_path__ + "static/media/planner.05d98eb1.gif";